import axios from "axios";
import { Cookies } from "react-cookie";

const API_URL = process.env.REACT_APP_API_URL;
let sessionExpiredHandled = false;

class BaseApi {
	API = async (options) => {
		const cookies = new Cookies();
		const token = cookies.get('PDATokenStage') || null;
		const authHeader = token ? `Bearer ${token}` : '';

		const client = axios.create({
			baseURL: API_URL,
			headers: {
				"Content-Type": "application/json",
				"Accept": "*/*",
				"Connection": "keep-alive",
				"authorization": authHeader
			},
		});

		return client(options)
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				if (error.response && error.response.status === 401) {
					if (!sessionExpiredHandled && window.location.pathname !== "/login") {
						sessionExpiredHandled = true;
						cookies.remove('PDATokenStage');
						alert("Your session has expired. Please log in again.");
						window.location.href = "/login";
					}
				} else {
					console.log("Network Error", error);
				}
				throw error;
			});
	}
}

export default BaseApi;